/**
 * FILE: assets/tn-subscription.js   (v8 — click Seal's controls + plain field set)
 * ----------------------------------------------------------------------
 * v7 only clicked Seal's controls and left the actual hidden
 * input[name="selling_plan"] entirely up to Seal's own JS to update.
 * That worked for Monthly (likely because "subscription" mode is Seal's
 * own default, so little needed to actually change), but not for
 * One-Time or the 3-Month interval — Seal's field stayed on whatever its
 * last real state was.
 *
 * v8 keeps the click simulation (so Seal's own UI/internal handling stays
 * in sync) AND adds back a PLAIN, simple direct set of
 * input[name="selling_plan"] — no Object.defineProperty locking, no
 * capture-phase submit interception, no API bypass. Just a normal
 * `.val(...)` set, applied both when a card is picked and once more right
 * as the Add to Cart button is clicked (last-moment safety net, still
 * using the totally standard, unmodified form submission).
 */
(function () {
  'use strict';

  function formatCents(cents) {
    return '$' + Math.floor(cents / 100);
  }

  function clickAllPossibleTargets($radio) {
    if (!$radio || !$radio.length) return;
    var seen = [];

    function clickIfNew($el) {
      if (!$el || !$el.length) return;
      var node = $el.get(0);
      if (!node || seen.indexOf(node) !== -1) return;
      seen.push(node);
      if (typeof node.click === 'function') {
        node.click();
      } else {
        node.dispatchEvent(new Event('click', { bubbles: true }));
      }
    }

    // 1. The native input itself
    clickIfNew($radio);
    // 2. Its immediate role="radio" wrapper (Seal's custom radio UI)
    clickIfNew($radio.closest('[role="radio"]'));
    // 3. Any role="button" ancestor (whole-row click target, seen on the
    //    One-Time option)
    clickIfNew($radio.closest('[role="button"]'));
    // 4. The outer option row itself, whether or not it had a role
    clickIfNew($radio.closest('.sls-option-container'));
  }

  function initSubscription($root) {
    var state = { planType: 'prepaid', unitPriceCents: 0, quantity: 1, sellingPlanId: '' };

    var $bundleToggle = $('[data-tn-bundle-toggle]').first();
    var $bundleTiles = $('[data-tn-bundle-tile]');

    var $sealSubRadio = $('input.sls-option[data-type="subscription"]');
    var $sealOneTimeRadio = $('input.sls-option[data-type="one_time"]');
    var $sealIntervalSelect = $('select[name="subs_interval"]');

    var oneBoxVariantId =
      $('[data-plan-type="onetime"] [data-tn-offer-radio]').data('variant-id') ||
      $('[data-onebox-variant-id]').data('onebox-variant-id');

    function forceVariantId() {
      if (oneBoxVariantId) {
        $('#product_id').val(oneBoxVariantId);
        $('input[name="id"]').val(oneBoxVariantId);
      }
    }

    // Plain, simple set — this is the actual field the cart form
    // submits. No locking, no interception — just make sure it's right.
    function syncSellingPlanField() {
      $('input[name="selling_plan"]').val(state.planType === 'onetime' ? '' : state.sellingPlanId);
    }

    function selectSealOption(planType, sellingPlanId) {
      if (planType === 'onetime') {
        clickAllPossibleTargets($sealOneTimeRadio);
        syncSellingPlanField();
        return;
      }

      // v3 FIX (Sep30): Seal renders one radio + one subs_interval <select> PER selling-plan
      // group ([LIVE] group 0 = 4/8/12 weeks, [Redesign] group 1 = 90-Day/Monthly/Ships Together).
      // v8 clicked only the FIRST subscription radio (group 0) and fired change on the FIRST
      // select, so Seal's own model sat on group 0 / "Delivery every 4 weeks" (4241129721).
      // Whenever Seal refreshed (debounced variant listeners / MutationObservers /
      // SealSubs.refreshCartAttributes) it rewrote input[name=selling_plan] with 4241129721.
      // Now: select the group whose <select> actually contains this plan, set THAT select,
      // so Seal's own model and our field agree no matter who writes last.
      var $targetOpt = sellingPlanId ? $('select[name="subs_interval"] option[value="' + sellingPlanId + '"]').first() : $();
      if ($targetOpt.length) {
        var $targetSelect = $targetOpt.closest('select');
        var $groupRadio = $targetOpt.closest('.sls-option-container').find('input.sls-option').not('[value="one_time"]').first();
        clickAllPossibleTargets($groupRadio);
        if ($targetSelect.val() !== String(sellingPlanId)) {
          $targetSelect.val(String(sellingPlanId));
        }
        $targetSelect.get(0).dispatchEvent(new Event('change', { bubbles: true }));
        $targetSelect.trigger('change');
      } else {
        clickAllPossibleTargets($sealSubRadio.first());
      }

      syncSellingPlanField();
    }

    function updateBundleTileSelection() {
      $bundleTiles.each(function () {
        var $tile = $(this);
        var checked = $tile.find('[data-tn-bundle-radio]').is(':checked');
        $tile.toggleClass('tn-bundle__tile--selected', checked);
      });
    }

    function refreshPriceDisplay() {
      var totalCents = state.unitPriceCents * ((state.planType === 'prepaid' || state.planType === 'onetime') ? 1 : state.quantity); // 90-Day and One-Time cards keep showing $/box (One-Time total sits under its stepper)

      var $card = $root.find('[data-tn-offer-card][data-plan-type="' + state.planType + '"]');
      $card.find('[data-tn-offer-price]').text(formatCents(totalCents));

      if (state.planType !== 'monthly') {
        var $monthlyCard = $root.find('[data-tn-offer-card][data-plan-type="monthly"]');
        var $monthlyRadio = $monthlyCard.find('[data-tn-offer-radio]');
        var monthlyUnit = parseInt($monthlyRadio.data('unit-price'), 10) || 0;
        $monthlyCard.find('[data-tn-offer-price]').text(formatCents(monthlyUnit));
      }
    }

    function selectCard($card, options) {
      var deferSealSync = options && options.deferSealSync;

      $root.find('[data-tn-offer-card]').removeClass('tn-subscription__card--selected');
      $card.addClass('tn-subscription__card--selected');
      $card.find('[data-tn-offer-radio]').prop('checked', true);

      var $input = $card.find('[data-tn-offer-radio]');
      state.planType = $card.data('plan-type');
      state.unitPriceCents = parseInt($input.data('unit-price'), 10) || 0;
      state.sellingPlanId = $input.data('selling-plan-id') || '';
      // 3-BOXES-AT-ONCE (preview Sep30): the 90-Day card carries data-qty (3 when the Seal
      // plan is pay-per-delivery, 1 while it is still prepaid). Other cards reset to 1.
      if (state.planType === 'prepaid') { state.quantity = parseInt($input.data('qty'), 10) || 1; }
      else if (state.planType === 'monthly') {
        // v2: don't carry the 90-Day qty (3) over; use the checked bundle tile if that block exists, else 1
        var $tileQty = $bundleTiles.find('[data-tn-bundle-radio]:checked');
        state.quantity = ($tileQty.length && parseInt($tileQty.val(), 10)) || 1;
      }
      else if (state.planType === 'onetime' && $qty.length) { state.quantity = qtyValue(); } // Otto Oct16: One-Time box stepper
      else { state.quantity = 1; }

      forceVariantId();
      syncSellingPlanField();

      if ($bundleToggle.length) {
        if (state.planType === 'monthly') {
          $bundleToggle.attr('hidden', false);
        } else {
          $bundleToggle.attr('hidden', true);
          state.quantity = 1;
          $bundleTiles.find('[data-tn-bundle-radio][value="1"]').prop('checked', true);
          updateBundleTileSelection();
        }
      }

      $('input[name="quantity"]').val(state.quantity);
      refreshPriceDisplay();

      if (!deferSealSync) {
        selectSealOption(state.planType, state.sellingPlanId);
      }
    }

    // Otto Oct16 PREVIEW: One-Time box stepper (1-20). Quantity only, on the same 1 Box variant.
    var $qty = $root.find('[data-tn-qty]').first();
    function qtyValue() { return parseInt($qty.find('[data-tn-qty-value]').text(), 10) || 1; }
    function renderQty(n) {
      var min = parseInt($qty.data('min'), 10) || 1, max = parseInt($qty.data('max'), 10) || 20;
      n = Math.max(min, Math.min(max, n));
      $qty.find('[data-tn-qty-value]').text(n);
      $qty.find('[data-tn-qty-minus]').prop('disabled', n <= min);
      $qty.find('[data-tn-qty-plus]').prop('disabled', n >= max);
      var unit = parseInt($root.find('[data-plan-type="onetime"] [data-tn-offer-radio]').data('unit-price'), 10) || 0;
      var $total = $qty.find('[data-tn-qty-total]');
      if (n > 1 && unit) { $total.text(formatCents(unit * n) + ' total').prop('hidden', false); } else { $total.text('').prop('hidden', true); }
      return n;
    }
    if ($qty.length) {
      $qty.on('click', function (e) {
        // Taps here must not re-run the card selection or toggle the label's radio.
        e.preventDefault();
        e.stopPropagation();
        var $btn = $(e.target).closest('[data-tn-qty-minus],[data-tn-qty-plus]');
        if (!$btn.length || $btn.prop('disabled')) return;
        var n = renderQty(qtyValue() + ($btn.is('[data-tn-qty-plus]') ? 1 : -1));
        if (state.planType === 'onetime') {
          state.quantity = n;
          forceVariantId();
          $('input[name="quantity"]').val(state.quantity);
        }
      });
      renderQty(1);
    }

    $root.find('[data-tn-offer-card]').on('click', function () {
      selectCard($(this));
    });

    $(document).on('click', '[data-tn-bundle-tile]', function () {
      var $tile = $(this);
      var qty = parseInt($tile.find('[data-tn-bundle-radio]').val(), 10) || 1;
      $tile.find('[data-tn-bundle-radio]').prop('checked', true);
      state.quantity = qty;
      updateBundleTileSelection();
      $('input[name="quantity"]').val(state.quantity);
      forceVariantId();
      refreshPriceDisplay();
    });

    forceVariantId();
    var $initial = $root.find('[data-tn-offer-card].tn-subscription__card--selected');
    if (!$initial.length) { $initial = $root.find('[data-tn-offer-card]').first(); }

    // ⚠️ FIX: a single delay wasn't reliable — Seal's own widget
    // apparently still lands back on ITS default (Monthly) at some point
    // after our first attempt, whatever that source of truth actually is
    // internally. Rather than guess the exact right moment, re-assert our
    // selection several times over a few seconds. syncSellingPlanField()
    // already keeps the real submitted field correct immediately and
    // throughout — these retries are specifically to also win control of
    // Seal's own internal/visual state.
    selectCard($initial, { deferSealSync: true });
    [300, 800, 1500, 3000].forEach(function (delay) {
      window.setTimeout(function () {
        selectSealOption(state.planType, state.sellingPlanId);
      }, delay);
    });

    // Last-moment safety net: right as the person clicks Add to Cart
    // (before the browser turns that into a form submission), re-run the
    // FULL selection (both the click simulation AND the plain field set)
    // one more time — not just the field set alone, since Seal appears to
    // rely on its own click-tracked state rather than re-reading the
    // field at submit time. No preventDefault, no interception — the
    // normal submission still happens exactly as Seal/the theme built it.
    // v3: capture-phase guard on click + submit, runs BEFORE the theme's/Seal's handlers read the form.
    function lastMomentSync() {
      forceVariantId();
      $('input[name="quantity"]').val(state.quantity);
      syncSellingPlanField();
    }
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [data-add-to-cart]')) { lastMomentSync(); }
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) { lastMomentSync(); }
    }, true);

    $(document).on('click', 'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [data-add-to-cart]', function () {
      selectSealOption(state.planType, state.sellingPlanId);
      forceVariantId();
      $('input[name="quantity"]').val(state.quantity);
    });
  }

  $(document).ready(function () {
    $('[data-tn-subscription]').each(function () {
      initSubscription($(this));
    });
  });
})();